import { Heading } from '@radix-ui/themes'
import * as React from 'react'

/* -------------------------------------------------------------------------------------------------
 * ProductName
 * -----------------------------------------------------------------------------------------------*/

type ProductNameProps = (typeof Heading)['defaultProps'] & {
	children: string
}

const ProductName: React.FC<ProductNameProps> = (props) => {
	const { children, ...rest } = props

	return (
		// @ts-ignore
		<Heading
			as="h3"
			color="gray"
			size="3"
			className="whitespace-pre-line"
			{...rest}
		>
			{children}
		</Heading>
	)
}
ProductName.displayName = 'ProductName'

/* -----------------------------------------------------------------------------------------------*/

export { ProductName }
